import { render } from "./TrainingForm.vue?vue&type=template&id=f84573a8"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__